import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from '../../../shared/standalone-imports';
import {StoreNavigationComponent} from '../../../shared/components/store-navigation/store-navigation.component';
import {RotaWeekDataComponent} from "../rota-week-data/rota-week-data.component";

/**
 * This component displays a weekly rota page.
 */
@Component({
  selector: 'app-rota-week',
  templateUrl: './rota-week.component.html',
  styleUrls: ['./rota-week.component.less'],
  imports: [SHARED_IMPORTS, StoreNavigationComponent, RotaWeekDataComponent]
})
export class RotaWeekComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** A week identifier of a rota to be displayed. */
  weekId: string;

  /**
   * Finds a week identifier from the URL, so a weekly rota could be displayed.
   */
  ngOnInit() {
    this.route.params
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                this.weekId = this.route.snapshot.paramMap.get('weekId');
                if (!this.weekId) {
                  this.router.navigateByUrl('/');
                }
              }
            });
  }
}
